module.exports = "/static/images/logo-badge.png";